import angular from 'angular';

function popupPreferences() {
    return {
        restrict: 'E',
        scope: {
            search: '='
        },
        template: require('./templates/popup-preferences.html')
    }
}

export default angular.module('directives.popupPreferences', []).directive('popupPreferences', popupPreferences).name;


// WEBPACK FOOTER //
// ./src/app/directives/popupPreferences.js